// extracted by mini-css-extract-plugin
export default {"lc-container":"SingleLayout__lc-container--lc-RFxu_"};